import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TransformationBanner } from './components/TransformationBanner';
import { ProblemSection } from './components/ProblemSection';
import { ContractorTypes } from './components/ContractorTypes';
import { StorySection } from './components/StorySection';
import { WhatYouGet } from './components/WhatYouGet';
import { Services } from './components/Services';
import { Gallery } from './components/Gallery';
import { VideoSpotlight } from './components/VideoSpotlight';
import { Process } from './components/Process';
import { Confidence } from './components/Confidence';
import { Reviews } from './components/Reviews';
import { ServiceArea } from './components/ServiceArea';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingEstimate } from './components/FloatingEstimate';
export function App() {
  return <div className="min-h-screen w-full bg-white font-sans" data-id="element-0" data-mp="3ikh5c1uvgeva">
      <Header data-id="element-1" data-mp="3ii4su47vuwpm" />
      <main data-id="element-2" data-mp="3mlj6wpc9h30f">
        <Hero data-id="element-3" data-mp="3ml13n8r6loj0" />
        <TransformationBanner data-id="element-4" data-mp="3mkhlps1j704z" />
        <ProblemSection data-id="element-5" data-mp="3mjq2lgp4euvl" />
        <ContractorTypes data-id="element-6" data-mp="3rc9em985thya" />
        <StorySection data-id="element-7" data-mp="3rbrcivytg9ig" />
        <WhatYouGet data-id="element-8" data-mp="3rdkie91luppe" />
        <Services data-id="element-9" data-mp="3rd191gq0t9mz" />
        <Gallery data-id="element-10" data-mp="3relvsk63foaa" />
        <VideoSpotlight data-id="element-11" data-mp="5os92t1uy7l" />
        <Process data-id="element-12" data-mp="4wxfu7a14id" />
        <Confidence data-id="element-13" data-mp="5ggje8nxyxz" />
        <Reviews data-id="element-14" data-mp="82j0zgp5o9c" />
        <ServiceArea data-id="element-15" data-mp="2zl3cjn8vpa6d" />
        <Faq data-id="element-16" data-mp="2zlv66six0xu0" />
        <FinalCta data-id="element-17" data-mp="2zm4xqkjlzd1t" />
      </main>
      <Footer data-id="element-18" data-mp="2zn69yscd25l4" />
      <FloatingEstimate data-id="element-19" data-mp="2zng1wlgyumtg" />
    </div>;
}